/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import Router from 'next/router';
import Cookies from 'js-cookie';
import Prismic from 'prismic-javascript';
import Subscribe from '../components/Home/Subscribe';
import TiledSection from '../components/Home/TiledSection';
import Team from '../components/Home/Team';
import BoardMembers from '../components/Home/BoardMembers';
import InfoCards from '../components/Home/InfoCards';

import * as homepageActions from '../redux/actions/homepage-actions';

import styles from './about.module.scss';

const head = () => {
    return (
        <Helmet>
            <title>Universal Tennis</title>
        </Helmet>
    );
};

class AboutPage extends Component {
    static async getInitialProps({ store }) {
        const { homepage } = store.getState();
        if (!(homepage && homepage.homepageContentLoaded)) {
            await store.dispatch(homepageActions.fetchHomepageContent());
        }
    }

    constructor(props) {
        super(props);

        this.state = { };
        this.redirectTo = this.redirectTo.bind(this);
    }

    componentDidMount() {
        const previewRef = Cookies.get(Prismic.previewCookie);
        if (previewRef) {
            const previewObj = JSON.parse(previewRef);
            if (previewObj['myutrcom.prismic.io']) {
                this.props.fetchHomepageContent(previewObj['myutrcom.prismic.io'].preview);
            }
        }
    }

    componentDidUpdate() {
        console.log('about props', this.props);
    }

    redirectTo(to) {
        Router.push(to);
    }

    render() {
        console.log('about props', this.props);
        const { homepage } = this.props;
        const tabContent = (homepage && homepage.homepageContent && homepage.homepageContent.tabs && homepage.homepageContent.tabs.about) || { sections: [], team: [] };

        const companyIPList = tabContent.investors_and_partners && tabContent.investors_and_partners.length > 0 && tabContent.investors_and_partners.filter((ip) => ip.type === 'company');
        const personIPList = tabContent.investors_and_partners && tabContent.investors_and_partners.length > 0 && tabContent.investors_and_partners.filter((ip) => ip.type === 'person');

        return (
            <div className={styles.aboutPage}>
                {head()}
                {/* <HeroStripe
                    heroImage={tabContent.image}
                    overlayPercent={tabContent.overlay_percent}
                /> */}
                <div className={`container ${styles.titleContainer}`}>
                    <h1 className={`${styles.title}`}>{tabContent.pagetitle}</h1>
                    <p className={`${styles.description}`}>{tabContent.description}</p>
                </div>

                {tabContent && tabContent.utr_reach && tabContent.utr_reach.length && (
                    <div className="container">
                        <div className="home-about-counter">
                            <div className="row mt24 mb24">
                                {tabContent.utr_reach.map((reach, i) => (
                                    <div className="col-4" key={`ur${i}`}>
                                        <h3 className={`text-center`}>{reach.reach_count}</h3>
                                        <p className="text-medium text-center fs16">{reach.reach_entity}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                {/* {tabContent && tabContent.featured_card_slider && tabContent.featured_card_slider.length && (
                    <FeaturedCardSlider featuredCards={tabContent.featured_card_slider} />
                )} */}
                {tabContent && tabContent.sections.map((section, i) => <TiledSection section={section} key={`section-${i}`} />)}
                {tabContent && tabContent.team && (
                    <Team
                        team={tabContent.team}
                        title={tabContent.team_title}
                        description={tabContent.team_description}
                    />
                )}
                {tabContent.board_members_title && tabContent.board_members && tabContent.board_members.length && (
                    <BoardMembers
                        title={tabContent.board_members_title}
                        members={tabContent.board_members}
                        link_prefix={`bm`}
                    />
                )}
                {tabContent.investors_and_partners_title && personIPList && personIPList.length && (
                    <BoardMembers
                        title={tabContent.investors_and_partners_title}
                        members={personIPList}
                        link_prefix={`ip`}
                    />
                )}
                {tabContent.investors_and_partners_title && companyIPList && companyIPList.length && (
                    <BoardMembers
                        title={personIPList && personIPList.length ? null : tabContent.investors_and_partners_title}
                        members={companyIPList}
                        link_prefix={`ip`}
                    />
                )}
                {tabContent && tabContent.info_cards && tabContent.info_cards.length && (
                    <InfoCards
                        infoCards={tabContent.info_cards}
                        className={`mb48`}
                        clampValue={2}
                    />
                )}
                <Subscribe />
            </div>
        );
    }
}

function mapStateToProps({ homepage }) {
    return { homepage };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchHomepageContent: token => {
            dispatch(homepageActions.fetchHomepageContent(token));
        } };
}
export default connect(mapStateToProps, mapDispatchToProps)(AboutPage);
